<template>
  <v-card
    class="
      full-width full-height
      d-flex
      flex-column
      main-container
      default-background
    "
    flat
  >
    <v-sheet
      v-if="!isMobile"
      class="d-flex align-center pl-6 pa-2 flex-grow-0 header-login-container"
    >
      <div @click="goHome">
        <v-img
          style="width: 48px"
          src="/static/img/logo_green.svg"
        ></v-img>
      </div>
      <div class="text-title-login">
        <!-- PHẦN MỀM QUẢN LÝ DỮ LIỆU VÀ CUNG CẤP DỊCH VỤ BẢN ĐỒ -->
        Phần mềm quản lý dữ liệu và cung cấp dịch vụ bản đồ
        </div>
    </v-sheet>
    <base-form
      ref="form"
      class="flex-grow-1 d-flex align-center justify-space-evenly"
      @submit="submitForm"
    >
      <v-card
        class="text-center d-flex justify-center align-cente pb-6 login-card"
        :flat="isMobile"
        :width="!isMobile ? '30%' : null"
      >
        <div class="full-width full-height px-4 py-6">
          <div class="full-width d-flex justify-center align-center">
            <div
              ><v-img
                style="width: 90px;"
                src="/static/img/logo_green.svg"
              ></v-img
            ></div>
          </div>
          <v-card-title>
            <div class="text-center full-width text-h5 font-weight-bold">
              Đăng nhập
            </div>
          </v-card-title>
          <v-card-text class="pb-0 pt-0">
            <v-text-field
              v-model="loginForm.username"
              autocomplete="username"
              dense
              :error-messages="errors.username || errors.email"
              height="50px"
              outlined
              placeholder="Tên đăng nhập"
              type="text"
              validate-on-blur
              style="border-radius: 24.5px"
            >
              <template #prepend-inner>
                <v-icon class="pt-2" style="color: #9b9da6; font-size: 20px">
                  mdi-account-outline
                </v-icon>
              </template>
            </v-text-field>
            <v-text-field
              v-model="loginForm.password"
              autocomplete="current-password"
              dense
              :error-messages="errors.password"
              height="50px"
              outlined
              placeholder="Mật khẩu"
              :type="password.show ? 'text' : 'password'"
              validate-on-blur
              style="border-radius: 24.5px"
            >
              <template #prepend-inner>
                <v-icon class="pt-2" style="color: #9b9da6; font-size: 20px">
                  mdi-lock-outline
                </v-icon>
              </template>
              <template #append>
                <v-icon
                  class="pt-2"
                  style="color: #9b9da6; font-size: 20px"
                  @click="password.show = !password.show"
                  >{{ password.show ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon
                >
              </template>
            </v-text-field>
          </v-card-text>
          <v-card-actions class="px-4 pt-0">
            <v-btn
              block
              class="text-none"
              color="#2B713A"
              dark
              depressed
              elevation="1"
              large
              :loading="loginRequest.requesting"
              @click="submitForm"
              style="border-radius: 24.5px"
            >
              Đăng nhập
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </base-form>
    <div>
      <div class="lg-version" v-if="!isMobile">
        <div class="text-caption" style="color: #ffffff; font-size: 14px">
          Copyright © 2021 - TRUNG TÂM THÔNG TIN VÀ DỮ LIỆU MÔI TRƯỜNG
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { getTitle, getCopyright, getVersion, getDescription } from '../constant'

export default {
  components: {},
  data() {
    return {
      isSelectRole: false,
      loginForm: {
        username: '',
        password: '',
      },
      errors: {
        username: '',
        password: '',
      },
      loginRequest: {
        requesting: false,

        data: {},
      },
      password: {
        show: false,
      },
    }
  },

  computed: {
    appName() {
      return getTitle()
    },
    appDescription() {
      return getDescription()
    },
    version() {
      return getVersion()
    },
    copyright() {
      return getCopyright()
    },
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
  },

  created() {},

  methods: {
    goHome(){
      this.$router.push('/')
    },
    async submitForm(e) {
      if (!(await this.$refs.form.validate())) return
      this.errors = {
        username: [],
        password: [],
      }
      this.requestLogin(this.loginForm)
    },

    async requestLogin(req) {
      if (this.loginRequest.requesting) return
      this.errors = {}
      try {
        this.loginForm.password = this.loginForm.password.trim()
        this.loginForm.username = this.loginForm.username.trim()
        this.loginRequest.requesting = true

        await this.$store.dispatch('auth/logIn', req)
        let nextRoute = this.$route.query['redirect'] || {
          name: 'home',
        }
        if (this.currentUser.roles.length > 1) {
          nextRoute = { name: 'login.select_role', query: this.$route.query }
        }
        this.$router.push(nextRoute)
      } catch (error) {
        console.error(error)
        this.loginRequest.requesting = false
        this.loginForm.password = ''
        if (error.response && error.response.status == 422) {
          this.errors = error.response.data.errors
        } else {
          this.$store.dispatch('notify/error', {
            message:
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : 'Đăng nhập thất bại',
            error,
          })
        }
      }
    },
  },
}
</script>
<style scoped>
.text-title-login {
  padding-left: 24px;
  font-size: 24px;
}
.login-card {
  max-width: 500px;
  min-width: 360px;
  border-radius: 40px;
  padding-top: 35px;
  box-shadow: 0px 2px 20px #cdd5f7 !important;
}
.header-login-container {
  width: 100%;
  left: 50px;
  border-bottom: #25352d;
  box-shadow: 1px 1px 20px 1px #454644
}
.lg-version {
  position: fixed;
  bottom: 30px;
  font-weight: bold;
  width: 100%;
  text-align: center;
}
.default-background {
  background-image: url(/static/img/background.svg);
  background-size: auto auto;
  background-color: #067e3f;
  background-repeat: no-repeat;
  background-position: right bottom;
}
.justify-space-evenly {
  -webkit-box-pack: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly;
}
</style>
